<div class="pagination-bar">
  <span class="pagination-label">{{
    totalCount() === 0
      ? '0'
      : ('app.admin.dailyFacts.pagination' | translate : {
          from: from,
          to: to,
          total: totalCount()
        })
  }}</span>
  <div class="pagination-controls">
    <button
      class="pagination-btn"
      [disabled]="page() === 0 || isLoading()"
      (click)="goToPage(page() - 1)"
    >
      {{ 'app.admin.dailyFacts.previous' | translate }}
    </button>
    <button
      class="pagination-btn"
      [disabled]="page() >= totalPages - 1 || isLoading()"
      (click)="goToPage(page() + 1)"
    >
      {{ 'app.admin.dailyFacts.next' | translate }}
    </button>
  </div>
</div>
